import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            Ticketed Compare — Football ticket price comparison
          </p>
          <p className="text-xs text-slate-600">
            Prices updated every 6 hours. All prices in USD.
          </p>
        </div>
      </div>
    </footer>
  );
}
